import React from "react";
import NTFooter from "./nt-footer";
import BaseFooter from "./base-footer";

const Footer = () => {
  return ["FAF-nt", "nrdata-orig"].includes(
    process.env.REACT_APP_STYLING_THEME ?? "",
  ) ? (
    <NTFooter />
  ) : (
    <BaseFooter />
  );
};

export default Footer;
